/**
 * StoreBar Reducer
 */

import * as types from '../../actions/storeBar/storeBarActionTypes';
import { StoreBarAction } from '../../actions/storeBar/storeBarActions';
import { ClubInfo } from '../../../components/Common/StoreBar/StoreBar.types';

/**
 * State 类型
 */
export interface StoreBarState {
  belongClubs: ClubInfo[];
  favoriteClubs: ClubInfo[];
  otherClubs: ClubInfo[];
  loading: boolean;
  error: string | null;
}

/**
 * 初始状态
 */
const initialState: StoreBarState = {
  belongClubs: [],
  favoriteClubs: [],
  otherClubs: [],
  loading: false,
  error: null,
};

/**
 * Reducer
 */
const storeBarReducer = (state = initialState, action: StoreBarAction): StoreBarState => {
  switch (action.type) {
    case types.FETCH_COMMON_CLUB_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.FETCH_COMMON_CLUB_LIST_SUCCESS:
      return {
        ...state,
        belongClubs: action.payload.belongClubs,
        favoriteClubs: action.payload.favoriteClubs,
        otherClubs: action.payload.otherClubs,
        loading: false,
        error: null,
      };

    case types.FETCH_COMMON_CLUB_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default storeBarReducer;
